import DaySubsidyInfo from "./DaySubsidyInfo";

export default DaySubsidyInfo;
